import { render, staticRenderFns } from "./SubKategoriCampaignPopup.vue?vue&type=template&id=33fd1874&scoped=true"
import script from "./SubKategoriCampaignPopup.vue?vue&type=script&lang=js"
export * from "./SubKategoriCampaignPopup.vue?vue&type=script&lang=js"
import style0 from "./SubKategoriCampaignPopup.vue?vue&type=style&index=0&id=33fd1874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fd1874",
  null
  
)

export default component.exports